import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "tw-w-full tw-mt-0 sm:tw-mt-20px"
};
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = {
  class: "tw-py-10px"
};
var _hoisted_4 = {
  key: 0,
  id: "box-mail-alert",
  class: "tw-grid tw-grid-cols-12-save-search tw-mt-25px"
};
var _hoisted_5 = {
  key: 1,
  id: "box-generic",
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_6 = {
  class: "tw-flex tw-items-center tw-justify-start tw-pl-10px"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  id: "required-phone",
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-0"
};
var _hoisted_11 = {
  class: "tw-text-12 tw-ml-5px tw-mb-10px tw-mt-20px"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "tw-font-semibold"
}, "Conferma", -1 /* HOISTED */);
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  id: "box-news",
  class: "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_16 = {
  class: "tw-mt-15px sm:tw-hidden tw-p-5px"
};
var _hoisted_17 = {
  class: "tw-mt-15px tw-hidden sm:tw-flex tw-justify-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_base_toggle = _resolveComponent("base-toggle");
  var _component_base_input = _resolveComponent("base-input");
  var _component_base_button = _resolveComponent("base-button");
  var _component_base_bt_modal = _resolveComponent("base-bt-modal");
  return _openBlock(), _createBlock(_component_base_bt_modal, {
    id: "contact-agency-success",
    "data-cy": "contact-agency-success",
    "show-modal": _ctx.show,
    "custom-modal-classes": "tw-w-full",
    "custom-modal-header-classes": "tw-pt-15px tw-px-15px !tw-p-0",
    "custom-modal-body-classes": "tw-flex tw-flex-col tw-px-20px tw-py-20px tw-mx-0 sm:tw-mx-15px lg:tw-mx-0",
    size: "modal-lg",
    "custom-modal-content-classes": "!tw-px-0",
    "with-custom-footer": true,
    onClosed: _ctx.onClosed
  }, {
    body: _withCtx(() => [_createCommentVNode(" ALERT "), _createVNode(_component_base_alert, {
      "alrt-class": "tw-alert-w-primary !tw-mb-0 !tw-mb-20px",
      text: _ctx.labels.request_sent + '. ' + _ctx.labels.request_sent_correctly_2,
      style: {
        "width": "90%"
      }
    }, null, 8 /* PROPS */, ["text"]), _createCommentVNode(" CONTENT "), _createElementVNode("div", _hoisted_1, [_createCommentVNode(" ACTIVATE SERVICES "), _createElementVNode("p", {
      class: "tw-text-22 tw-font-semibold tw-mb-0 sm:tw-mb-10px tw-mt-0 tw-leading-[15px] tw-hidden sm:tw-block",
      innerHTML: _ctx.labels.additional_services
    }, null, 8 /* PROPS */, _hoisted_2), _createCommentVNode(" CHECKBOX SERVICES "), _createElementVNode("div", _hoisted_3, [_createCommentVNode(" 1) MAIL ALERT "), _ctx.showSaveSearch ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_base_toggle, {
      modelValue: _ctx.requestData.toggleSearch,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.requestData.toggleSearch = $event),
      label: 'Voglio ricevere immobili simili sulla mia email',
      class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px"
    }, null, 8 /* PROPS */, ["modelValue"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" TODO: check user logged  "), _createCommentVNode(" @input=\"checkIfUserIsLogged\" "), _createCommentVNode(" :label=\"isUserLogged ? 'Voglio ricevere immobili simili sulla mia email' : 'Voglio ricevere immobili simili sulla mia email (Login necessario)'\" "), _createCommentVNode(" 2) GENERIC "), _ctx.showGenericRequest ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_base_toggle, {
      modelValue: _ctx.requestData.toggleGeneric,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.requestData.toggleGeneric = $event),
      label: _ctx.labels.send_generic_request,
      class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px"
    }, null, 8 /* PROPS */, ["modelValue", "label"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" 3) MORTGAGE REQUEST "), _ctx.isContractTypeSale && _ctx.showGenericRequest && !_ctx.isTecnocasaFranchise ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createElementVNode("div", {
      id: "box-mortgage",
      class: _normalizeClass(["tw-grid tw-grid-cols-12-generic-request tw-mt-25px", _ctx.requestData.toggleMortgage ? 'selected' : ''])
    }, [_createVNode(_component_base_toggle, {
      id: "toggle-mortgage",
      modelValue: _ctx.requestData.toggleMortgage,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.requestData.toggleMortgage = $event),
      label: '',
      class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px",
      "custom-label": true,
      onInput: _ctx.catchEmittedMortgageToggle
    }, {
      rightLabel: _withCtx(() => [_createElementVNode("div", _hoisted_6, [!_ctx.isFranchiseToExclude ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "max-sm:tw-max-w-[200px] tw-mt-5px sm:tw-flex",
        innerHTML: "".concat(_ctx.labels.mortgage_request)
      }, null, 8 /* PROPS */, _hoisted_7)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "max-sm:tw-max-w-[200px] tw-mt-5px sm:tw-flex",
        innerHTML: "".concat(_ctx.labels.mortgage_request_2)
      }, null, 8 /* PROPS */, _hoisted_8)), !_ctx.isFranchiseToExclude ? (_openBlock(), _createElementBlock("img", {
        key: 2,
        class: "tw-mx-5px tw-w-auto sm:tw-block",
        width: "73",
        height: "25",
        src: _ctx.icons.crediPass,
        alt: "icona ente creditore"
      }, null, 8 /* PROPS */, _hoisted_9)) : _createCommentVNode("v-if", true)])]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onInput"])], 2 /* CLASS */), _withDirectives(_createElementVNode("div", _hoisted_10, [!_ctx.isUserLogged ? (_openBlock(), _createBlock(_component_base_input, {
      key: 0,
      id: "name",
      modelValue: _ctx.requestData.name,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.requestData.name = $event),
      name: "name",
      "label-text": "Nome",
      "is-valid": _ctx.isValid(_ctx.v$.requestData.name)
    }, null, 8 /* PROPS */, ["modelValue", "is-valid"])) : _createCommentVNode("v-if", true), _createVNode(_component_base_input, {
      id: "phone",
      modelValue: _ctx.requestData.phone,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.requestData.phone = $event),
      name: "phone",
      type: "tel",
      "label-text": "Telefono",
      "is-valid": _ctx.isValid(_ctx.v$.requestData.phone),
      onFocusout: _ctx.checkIfValidPhone
    }, null, 8 /* PROPS */, ["modelValue", "is-valid", "onFocusout"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", null, [_createTextVNode(" Cliccando "), _hoisted_12, _createTextVNode(", dichiaro di aver preso visione dell' "), _createElementVNode("span", {
      innerHTML: _ctx.wkLabels.privacyPolicy2
    }, null, 8 /* PROPS */, _hoisted_13), _createTextVNode(" ("), _createElementVNode("a", {
      class: "tw-underline",
      href: "#",
      onClick: _cache[5] || (_cache[5] = _withModifiers(
      //@ts-ignore
      function () {
        return _ctx.openWikiPrivacy && _ctx.openWikiPrivacy(...arguments);
      }, ["prevent"])),
      innerHTML: _ctx.wkLabels.purpose + ' J'
    }, null, 8 /* PROPS */, _hoisted_14), _createTextVNode(") ")])])], 512 /* NEED_PATCH */), [[_vShow, _ctx.requestData.toggleGeneric || _ctx.requestData.toggleMortgage]])], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true), _createCommentVNode(" 4) RE-NEWS"), _createElementVNode("div", _hoisted_15, [_createVNode(_component_base_toggle, {
      id: "toggle-news",
      modelValue: _ctx.requestData.toggleNews,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.requestData.toggleNews = $event),
      label: "\n              ".concat(_ctx.labels.news_request, "\n               <u><a href='").concat(_ctx.wikicasaNewsUrl, "' target='_blank'>").concat(_ctx.labels.news_request_1, "</a></u>\n              ").concat(_ctx.labels.news_request_2, "\n              "),
      class: "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px"
    }, null, 8 /* PROPS */, ["modelValue", "label"])])])])]),
    footer: _withCtx(() => [_createCommentVNode(" CONFIRM/SAVE BUTTONS "), _createElementVNode("div", _hoisted_16, [_createVNode(_component_base_button, {
      class: "tw-w-full tw-btn-w-primary tw-flex tw-justify-center",
      "is-loading": _ctx.isLoading,
      onClick: _cache[7] || (_cache[7] = $event => _ctx.enterPressedCb && _ctx.enterPressedCb())
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-loading"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_base_button, {
      class: "tw-btn-w-primary casm-submit-btn",
      "is-loading": _ctx.isLoading,
      onClick: _ctx.enterPressedCb
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-loading", "onClick"])])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "onClosed"]);
}